import React from "react";
import { Section, Text } from "@/components";
import "./index.css"; // Assuming you have a CSS file for additional styles

export const DataSecuritySection = (): JSX.Element => {
  // Security features data for mapping
  const securityFeatures = [
    {
      id: 1,
      title: "Run IntelliRoom™ on Your Terms",
      texts: [
        "Deploy on your own cloud, dedicated",
        "servers, or secure on-premises hardware",
      ]
    },
    {
      id: 2,
      title: "Local Inference, Zero Leakage",
      texts: [
        "All AI processing stays within your private",
        "environment no external calls, no exposure."
      ]
    },
    {
      id: 3,
      title: "Enterprise-Only Access",
      texts: [
        "These advanced configurations are available",
        "by request for qualified enterprise customers."
      ]
    }
  ];

  return (
    <Section id="data-security-section" className="data-security-section bg-[#0E0E0E] gap-10 md:gap-16 px-10 md:px-0 mx-0 z-[1]">
      <div className="relative max-w-[1120px]">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="data-security-title-group flex flex-col w-[400px] lg:w-[465px] items-start gap-4 mb-11 lg:mb-0">
            <div className="mt-0 lg:mt-[-60px] flex flex-col items-center lg:items-start gap-4">
              <Text.Heading size="sm" className="leading-[54px] text-center lg:text-left">
                <div className="security-title font-calSans font-400 text-[36px] leading-[38px] md:text-[44px] md:leading-[55px]">Air-Gapped AI.</div>
                <div className="security-title font-calSans font-400 text-[36px] leading-[38px] md:text-[44px] md:leading-[55px]">Local Inference.</div>
                <div className="maxium-security font-calSans font-400 text-[36px] leading-[38px] md:text-[44px] md:leading-[55px]">Maximum Privacy.</div>
              </Text.Heading>

              <Text.Description size="md" className="font-normal !text-[#A9AAB0] md:!text-[#A9AAB0] text-center sm:!text-[16px] sm:!leading-[22px] lg:text-left">
                For enterprise customers with the highest security requirements, IntelliRoom™ offers fully private deployments, where your data never leaves your infrastructure and AI runs inside your walls.
              </Text.Description>
            </div>
          </div>

          <div className="w-full lg:w-auto relative rounded-[10px] overflow-hidden border-none">
            <div className="w-full flex justify-center">
              <div
                className="flex max-w-[310px] lg:max-w-[406px]"
              >
                <img
                  className="h-auto z-1"
                  alt="One one"
                  src="/images/home/key.png"
                  loading="lazy" // Added lazy loading
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[-50px] mb-2 lg:mb-[96px] max-w-[1097px] grid grid-cols-1 lg:grid-cols-3 gap-[45px] lg:gap-[40px] place-items-center z-10 text-center">
          {securityFeatures.map((feature) => (
            <div key={feature.id} className="relative flex security-card w-[339px] h-[146px] z-10">
              <img
                src="/images/home/circle-check.svg"
                alt="Check icon"
                className="absolute top-[-24px] left-[calc(50%-24px)] w-12 h-12"
                loading="lazy" // Added lazy loading
              />
              <div className="relative m-auto">
                <div className="gap-1 text-center">
                  <Text.Description size="sm" className="!font-semibold text-white mb-2 !text-[18px] !leading-[20px]">
                    {feature.title}
                  </Text.Description>

                  {feature.texts.map((text, index) => (
                    <Text.Description
                      key={`security-${feature.id}-${index}`}
                      size="xs"
                      className="font-light !text-[#E3E3E3] !text-[14px]"
                    >
                      {text}
                    </Text.Description>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};
